
export const sFechaPublicacion = '2025-12-03T13:52:35.3799761-06:00';
export const sVersion = 'vf1.1.512031352';
            